module.exports = __webpack_public_path__ + "img/0S6A0045.893a2b53.jpg";